/* The search bar gets out of the dock's way.

   On a phone held upright the search band is nearly the full width of the
   screen, and the floating column — WhatsApp, call, the assistant — is fixed
   to the bottom right. Scroll until the bar passes through that corner and
   the blue circles sit on top of the blue search button: three overlapping
   discs and no way to tell which one a thumb would hit.

   Reserving the corner permanently would shorten the bar on every screen,
   including the ones where nothing overlaps. So the bar ducks instead: while
   the dock is level with it, the wrapper narrows just enough to clear it, and
   it goes back to full width the moment the bar scrolls clear. The width and
   the transition are in gs-bits.css; this file only measures and sets
   --gs-duck.

   WIDTH, NOT MARGIN. The first version set a right margin and nothing moved:
   something in this theme zeroes the margin on that element even against an
   inline style. Narrowing it works, so that is what gs-bits.css does.

   MEASURED AGAINST THE UNDUCKED EDGE. Ducking moves the bar's right edge
   left, which would make the next measurement report no overlap, which would
   un-duck it, which would overlap again. Adding the current duck back before
   comparing is what stops it flickering.

   SCROLL IS LISTENED FOR IN THE CAPTURE PHASE, on the document. Horizon
   scrolls a .page-wrapper element rather than the document, so a scroll
   listener on window never fires here — the same trap gs-scroll.js exists
   for. Scroll events do not bubble, but they can be captured.

   Only fixed things on the right half of the screen count. Back-to-top is
   bottom left, and narrowing the bar would never clear it. */

(function () {
  'use strict';

  var wraps = Array.prototype.slice.call(document.querySelectorAll('.gs-search__wrap'));
  if (!wraps.length) return;

  var DOCKS = ['.gs-fab', '.gs-ai', '.gs-offer'];
  var GAP = 12;    // breathing room between the go button and the first circle
  var FLOOR = 190; // never squeeze the bar narrower than this

  function blockers() {
    var out = [];
    var half = window.innerWidth / 2;

    DOCKS.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (node) {
        var cs = window.getComputedStyle(node);
        if (cs.position !== 'fixed') return;
        if (cs.display === 'none' || cs.visibility === 'hidden') return;
        if (parseFloat(cs.opacity) < 0.05) return;

        var r = node.getBoundingClientRect();
        if (r.width < 4 || r.height < 4) return;
        if (r.left < half) return; // left-hand furniture: ducking cannot help

        out.push(r);
      });
    });

    return out;
  }

  function apply(wrap, want) {
    var now = parseFloat(wrap.dataset.gsDuck || '0') || 0;
    if (want === now) return;
    wrap.dataset.gsDuck = String(want);
    wrap.style.setProperty('--gs-duck', want + 'px');
    wrap.classList.toggle('is-ducked', want > 0);
  }

  function tick() {
    var found = blockers();

    wraps.forEach(function (wrap) {
      var now = parseFloat(wrap.dataset.gsDuck || '0') || 0;
      var r = wrap.getBoundingClientRect();
      if (r.width < 1 && r.height < 1) return; // not laid out yet

      var edge = r.right + now; // where the bar would end if it were not ducked
      var full = r.width + now;
      var want = 0;

      found.forEach(function (d) {
        if (d.bottom < r.top || d.top > r.bottom) return; // not level with the bar
        if (d.left >= edge) return;                       // already clear of it
        var need = edge - d.left + GAP;
        if (need > want) want = need;
      });

      var most = Math.max(0, full - FLOOR);
      if (want > most) want = most;

      apply(wrap, Math.round(want));
    });
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      tick();
    });
  }

  /* A width change is a fresh start: a duck worked out for a wide window is
     meaningless on a narrow one, and leaving it in place skews the next
     measurement. */
  function reflow() {
    wraps.forEach(function (wrap) { apply(wrap, 0); });
    window.requestAnimationFrame(tick);
  }

  document.addEventListener('scroll', soon, true);
  window.addEventListener('resize', reflow);
  window.addEventListener('orientationchange', reflow);

  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(soon);
    wraps.forEach(function (w) { ro.observe(w); });
  }

  /* The dock is its own section and the assistant bubble arrives later still,
     so take a few more readings before settling. */
  tick();
  [200, 600, 1400, 3000].forEach(function (ms) { window.setTimeout(tick, ms); });
})();